import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import NumberSetting from "../../../../../../../components/global/Settings/NumberSetting";
import BoolSetting from "../../../../../../../components/global/Settings/BoolSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";
import { useGetSettingsQuery } from "../../../../../../../newapi/global/generalApiSlice";
import { useGetEnumsQuery } from "../../../../../../../newapi/global/generalApiSlice";
import { useGetInvoiceProductsSelectQuery } from "../../../../../../../newapi/financial/invoiceProductSlice";

const Invoicing = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [view, setView] = useState({
    title: 'invoicing',
    icon: <ReceiptLongIcon />,
  });

  const { data: settings} = useGetSettingsQuery("invoicing");
  const { data: invoiceProducts } = useGetInvoiceProductsSelectQuery();
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);

  const palletspotOptions = [
    {id: "palletspot", value: "palletspot", name: t("palletspot")},
    {id: "volume", value: "volume", name: t("volume")},
    {id: "warehouselocation_type", value: "warehouselocation_type", name: t("warehouse_location_type")},
  ];

  const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("time_based_frequencies");
  const countDefintions = [
    {
      id: "average",
      value: "average",
      name: t('average')
    },
    {
      id: "highest",
      value: "highest",
      name: t('highest')
    }
  ]

  return (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 2,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            // background:"purple",
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_invoicing_title")}</Subheading>
            <Text light>{t("core_invoicing_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>
        {/* <GridActions></GridActions> */}
        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            display:"flex",
            flexDirection:"column",
            gap:3,
            pt:3,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
             gap:2.5,
             overflow:"auto",
             pb:11,
              // display:"none"
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
            
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              display:"flex",
              px: 3,
              flexDirection:"column",
              gap:1,
            }}
          >
            <BoolSetting manualSave onChange={handleChange} settings={settings} variant={1} skey="invoicing_auto_invoice_palletspots"/>
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              display:"flex",
              px: 3,
              flexDirection:"column",
              gap:1,
            }}
          >
            <BoolSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            variant={1} 
            skey="invoicing_calculate_invoice_category"
              explainer={true}
              explainerTitle={t("invoicing_calculate_invoice_category_explainer_title")}
              explainerText={t("invoicing_calculate_invoice_category_explainer_text")}/>
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              display:"flex",
              px: 3,
              flexDirection:"column",
              gap:1,
            }}
          >
            <BoolSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            variant={1} 
            skey="invoicing_tier_pricing"
              explainer={true}
              explainerTitle={t("invoicing_tier_pricing_explainer_title")}
              explainerText={t("invoicing_tier_pricing_explainer_text")}/>
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              display:"flex",
              px: 3,
              flexDirection:"column",
              gap:1,
            }}
          >
            <BoolSetting manualSave onChange={handleChange} settings={settings} variant={1} skey="invoicing_follow_up_shipment"/>
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              display:"flex",
              px: 3,
              flexDirection:"column",
              gap:1,
            }}
          >
            <DropdownSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            objects={palletspotOptions} 
            noselection={"choose_type"}
            variant={"default"} 
            skey="invoicing_palletspot_type"
            />
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
                  px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <DropdownSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            objects={globalEnums ? globalEnums["time.based.frequencies"].filter(x => x !== "monthly").map((item, index) => ({ id: item, value: item, name: t(item) })) : []} 
            noselection={"choose_option"}
            variant={"default"} 
            skey="invoicing_palletspot_frequency"
            />
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
                  px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <DropdownSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            objects={countDefintions} 
            noselection={"choose_option"}
            variant={"default"} 
            skey="invoicing_palletspots_count_definition"
            />
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
                  px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
            <DropdownSetting 
            manualSave
            onChange={handleChange}
            valueKey={"id"}
            settings={settings} 
            searchOptions={{
                enabled: true,
                placeholder: t("search_invoice_products")
            }}
            objects={invoiceProducts ?? []} 
            noselection={"choose_option"}
            variant={"default"} 
            skey="invoicing_palletspot_standard_product_id"
            />
          </Box>
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
                  px: 3,
              display:"flex",
              flexDirection:"column",
              gap:1,
            }}
          >
          <NumberSetting manualSave hideSaveButton onChange={handleChange} maxWidth={240} settings={settings} skey="invoicing_palletspot_volume_divisor"/>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Invoicing;
